import { IndicatorPill } from "@codat/orchard-ui";
import * as React from "react";

import { ConnectorHost, GetConnectorHost } from "../../utilsConnectorStatus";

interface Props {
  value: {
    type: ConnectorHost;
  };
}

const TypePill: React.FC<Pick<Props, "value">> = ({ value }) => {
  const connectorType = GetConnectorHost(value.type);

  return (
    <div
      title={`${connectorType.Name} : ${connectorType.Description}`}
      style={{ textAlign: "center" }}
    >
      <IndicatorPill label={connectorType.Name} color={connectorType.Color} />
    </div>
  );
};

export default TypePill;
